module.exports = __webpack_public_path__ + "media/images/emblems/Corsier-coat_of_arms-e2b352ded837bb18359f0af3d91e5ce8.svg";